import React from "react";

function ViewComplaints() {
  return (
  <></>
  );
}

export default ViewComplaints;
